
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': '建立儀表板',
	'dashboard': '儀表板',
	'dashboardTemplate': '儀表板範本',
	'createAV': '建立',
	'createAvEditNameLabel': '1. 命名您的視圖',
	'createAvSelectTemplateLabel': '2. 選取範本',
	'tabLayoutLabel': '已加上標籤的範本',
	'infographicsLayoutLabel': '資訊圖範本',
	'singlePageLayoutLabel': '單一網頁範本',
	'customLayoutLabel': '自訂範本',
	'freeformTemplate': '開放式',
	'freeformTemplateDesc': '不論螢幕大小為何，開放式佈置中的視覺化就是您在視圖中調整並放置的樣子。在其他佈置中，會調整視覺化的大小和位置，使其可放入畫面中。',
	'NoTemplate': '開放式表單',
	'Template1': '空白',
	'Template2': '標題 1 X 2',
	'Template3': '上 2 下 1',
	'Template4': '上 4 下 1',
	'Template5': '標底 1 X 2',
	'Template6': '3 併 [上 1 下 1]',
	'Template7': '4 併 [上 3 下 1]',
	'Template8': '上 2 下 3 X 2',
	'Template9': '2 X 2',
	'Template10': '1 X 2 併 [上 2 X 2 下 1]',
	'Template11': '上 3 X 1，下 1 X 2',
	'Template12': '[上 2 下 1] 併 [1 X 2]',
	'Template13': '1 併 [1 X 2] 併 [1 X 4]',
	'Template22': '上 1 下 2 X 2',
	'Template14': '1 併 1',
	'Template15': '[上 1 下 1] 併 1',
	'Template16': '1 併 [上 1 下 1]',
	'Template17': '[上 1 下 1] 併 [上 1 下 1]',
	'Template18': '[上 1 下 1] 併 1',
	'Template19': '[上 1 下 2] 併 1',
	'Template20': '[上 1 下 2] X 1',
	'Template21': '[上 1 下 1 下 2] X 1',
	'Template23': '放下區域空白',
	'Infographics1': '空白',
	'Infographics2': '4 列',
	'Infographics3': '4 列，含標頭',
	'Infographics4': '2 X 4',
	'Infographics5': '大型上層顯示，暨 2 X 2',
	'Infographics6': '2 X 4，具垂直間隙',
	'Infographics7': '2 X 4，錯列',
	'Infographics8': '網球場格式',
	'Infographics9': '3 X 4',
	'Infographics10': '4 X 8',
	'createAvDashboardLabel': '佈置',
	'dashboard_template_save_success': '已儲存您的儀表板範本。',
	'dashboard_template_prefix': '範本："%{name}"',
	'dashboard_template_filters_removed': '已移除畫布上的過濾器。',
	'createAvTabLabel': '已加上標籤的',
	'createAvInfographicsLabel': '資訊圖表',
	'createAvSinglepageLabel': '單一頁',
	'createAvCustomLabel': '自訂',
	'loadMoreLabel': '載入更多...',
	'backLabel': '回上頁',
	'addSourceLabel': '新增來源',
	'pinLabel': '固定',
	'errorLoadingDataSetMetaData': '讀取 meta 資料時發生錯誤',
	'errorLoadingDataSets': '載入資料集清單時發生錯誤',
	'errorLoadingDataSet': '資料集 "%{datasetName}" 的 meta 資料未載入。如需詳細資料，請聯絡您的管理者。',
	'okButton': '確定',
	'createButton': '建立',
	'cancelButton': '取消',
	'copyButton': '複製',
	'selectTemplateLabel': '選取範本',
	'createBoardTitle': '建立儀表板',
	'createBoardSubtitle': '選取儀表板的範本',
	'noSourcesSelectedLabel': '未選取來源',
	'find_label': '尋找',
	'noDashboardFound': '無法擷取儀表板。可能它不再存在，或您沒有足夠的專用權檢視它。',
	'errorLabel': '錯誤',
	'defaultName': '新建儀表板',
	'noDashboardCapability': '您沒有執行儀表板應用程式的能力',
	'noDashboardPermission': '您的專用權不足，無法檢視此儀表板',
	'sourceNotFound': '我們無法載入視覺化，因為無法使用其關聯的來源 "%{sourceName}"',
	'cmDuplicateName': '具有此名稱的項目已存在。請嘗試另一個名稱',
	'cmEmptySelection': '已刪除儀表板。請嘗試另存為新的儀表板。',
	'propTheme': '視覺化佈景主題',
	'legacyThemeLabel': '舊式',
	'carbonGrey10Label': '副本 X 亮',
	'carbonGrey100Label': '副本 X 暗',
	'titleTextLabel': '標題',
	'titleSmallTextLabel': '小型標題',
	'subtitleTextLabel': '子標題',
	'bodyTextLabel': '主體',
	'bodySmallTextLabel': '小型主體',
	'captionTextLabel': '標題',
	'quoteTextLabel': '引用',
	'quoteSmallTextLabel': '小型引用',
	'responsiveTextLabel': '自動調整大小',
	'mediaWidgetLabel': '媒體',
	'webpageWidgetLabel': '網頁',
	'imageWidgetLabel': '影像',
	'textWidgetLabel': '文字',
	'notebookWidgetLabel': '記事本',
	'multipurposeWidgetLabel': '多用途',
	'textPlaceHolder': '按一下以編輯文字',
	'titlePlaceHolder': '按一下以編輯標題',
	'toggleEditModeLabel': '切換至編輯',
	'togglePreviewModeLabel': '切換至預覽',
	'editDashboardCoachMarkTitle': '編輯儀表板',
	'editDashboardCoachMarkContents': '按一下鉛筆圖示以編輯此儀表板。',
	'addDataCoachMarkTitle': '新增資料',
	'addDataDashboardCoachMarkContents': '將資料從資料畫面拖放至儀表板。',
	'pageSelectWarning': '請選取標籤。',
	'screenshot_label': '儀表板 %{title}',
	'screenshot_label_tab': '儀表板 %{title} 的標籤 %{tabName}',
	'dataAssetPropertiesLabel': '視覺化內容',
	'modelFilter': '過濾',
	'invertSelectionToolTip': '反轉過濾器選項',
	'clearFilterValueToolTip': '清除過濾器值',
	'invertFilterSelection': '反轉',
	'clearTextFilterValue': '清除',
	'filterConditionLabel': '過濾條件',
	'applyFilter': '套用過濾',
	'itemCountText': '已選取 %{itemCount} 個項目',
	'itemExcludeCountText': '已排除 %{itemCount} 個項目',
	'moreMembers': '顯示更多...',
	'searchHierarchyMembers': '使用搜尋來尋找成員...',
	'propHideEmpty': '隱藏空項目',
	'propColorOrder': '顏色順序',
	'propElementColor': '視覺化元素顏色',
	'propLineColor': '折線圖顏色',
	'propLineAndSymbolColor': '線條和符號顏色',
	'propColumnColor': '直條圖顏色',
	'propBarColor': '長條圖顏色',
	'propWordColor': '文字顏色',
	'propAreaColor': '區域顏色',
	'propRadialbarColor': '放射狀長條圖顏色',
	'propColorPalettes': 'color 選用區',
	'propDashboardColorPalette': '現行儀表板選用區',
	'propNewDashboardPaletteLabel': '建立自訂儀表板選用區',
	'propDashboardChangePaletteLink': '變更儀表板選用區',
	'propHideLeafNode': '隱藏前導標籤',
	'propOpacity': '不透明',
	'propOpacityDescription': '將物件設為更透明或更不透明。鍵入一個介於 0 與 100 之間的值',
	'addATab': '新增標籤',
	'propFredIsRed': '顏色一致性',
	'areaChartCaption': '區域圖',
	'areaChartDataSlot_categoriesLabel': '軸標籤',
	'areaChartDataSlot_valuesLabel': '值',
	'areaChartProp_colorPaletteLabel': 'color 選用區',
	'areaChartProp_lineColorLabel': '區域顏色',
	'areaChartProp_interpolationLabel': '平滑線條',
	'areaChartProp_interpolationDescription': '連接資料點的線條是曲線。',
	'areaChartProp_hideGridLinesLabel': '隱藏格線',
	'areaChartProp_hideGridLinesDescription': '隱藏格線',
	'areaChartProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'areaChartProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'areaChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'areaChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'areaChartProp_suppressZerosLabel': '隱藏空項目',
	'areaChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'barChartCaption': '長條圖',
	'barChartDataSlot_categoriesLabel': '軸標籤',
	'barChartDataSlot_valuesLabel': '值',
	'barChartProp_colorPaletteLabel': 'color 選用區',
	'barChartProp_elementColorLabel': '長條圖顏色',
	'barChartProp_hideGridLinesLabel': '隱藏格線',
	'barChartProp_hideGridLinesDescription': '隱藏格線',
	'barChartProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'barChartProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'barChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'barChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'barChartProp_suppressZerosLabel': '隱藏空項目',
	'barChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'columnChartCaption': '直條圖',
	'columnChartDataSlot_categoriesLabel': '軸標籤',
	'columnChartDataSlot_valuesLabel': '值',
	'columnChartProp_colorPaletteLabel': 'color 選用區',
	'columnChartProp_elementColorLabel': '直條圖顏色',
	'columnChartProp_hideGridLinesLabel': '隱藏格線',
	'columnChartProp_hideGridLinesDescription': '隱藏格線',
	'columnChartProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'columnChartProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'columnChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'columnChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'columnChartProp_suppressZerosLabel': '隱藏空項目',
	'columnChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'bubbleChartCaption': '泡泡圖',
	'bubbleChartDataSlot_xAxisLabel': '水平軸',
	'bubbleChartDataSlot_yAxisLabel': '垂直軸',
	'bubbleChartDataSlot_sizeLabel': '大小依據',
	'bubbleChartDataSlot_colorLabel': '用色方式',
	'bubbleChartProp_colorPaletteLabel': 'color 選用區',
	'bubbleChartProp_hideGridLinesLabel': '隱藏格線',
	'bubbleChartProp_hideGridLinesDescription': '隱藏格線',
	'bubbleChartProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'bubbleChartProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'bubbleChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'bubbleChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'bubbleChartProp_hideLegendLabel': '隱藏圖註',
	'bubbleChartProp_hideLegendDescription': '隱藏圖註。',
	'bubbleChartProp_legendPositionLabel': '圖註位置',
	'lineChartCaption': '折線圖',
	'lineChartDataSlot_categoriesLabel': '軸標籤',
	'lineChartDataSlot_valuesLabel': '值',
	'lineChartProp_colorPaletteLabel': 'color 選用區',
	'lineChartProp_lineColorLabel': '線條和符號顏色',
	'lineChartProp_symbolShapeLabel': '符號形狀',
	'lineChartProp_hideSymbolsLabel': '隱藏符號',
	'lineChartProp_hideSymbolsDescription': '隱藏符號',
	'lineChartProp_hideDataLinesLabel': '隱藏線條',
	'lineChartProp_hideDataLinesDescription': '隱藏線條',
	'lineChartProp_interpolationLabel': '平滑線條',
	'lineChartProp_interpolationDescription': '連接資料點的線條是曲線。',
	'lineChartProp_hideGridLinesLabel': '隱藏格線',
	'lineChartProp_hideGridLinesDescription': '隱藏格線',
	'lineChartProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'lineChartProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'lineChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'lineChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'lineChartProp_suppressZerosLabel': '隱藏空項目',
	'lineChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'packedBubbleChart1CatCaption': '壓縮泡泡圖',
	'packedBubbleChart1CatDataSlot_categoriesLabel': '種類',
	'packedBubbleChart1CatDataSlot_sizeLabel': '大小依據',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'color 選用區',
	'packedBubbleChart1CatProp_elementColorLabel': '泡泡顏色',
	'packedBubbleChart1CatProp_hideLabelLabel': '隱藏標籤',
	'packedBubbleChart1CatProp_hideValueLabel': '隱藏值',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': '維護軸刻度',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'packedBubbleChart1CatProp_suppressZerosLabel': '隱藏空項目',
	'packedBubbleChart1CatProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'heatChartCaption': '熱圖',
	'heatChartDataSlot_valuesLabel': '熱度依據',
	'heatChartDataSlot_xAxisLabel': '水平軸',
	'heatChartDataSlot_yAxisLabel': '垂直軸',
	'heatChartProp_colorPaletteLabel': 'color 選用區',
	'heatChartProp_heatScalePaletteLabel': '顏色順序',
	'heatChartProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'heatChartProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'heatChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'heatChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'heatChartProp_suppressZerosLabel': '隱藏空項目',
	'heatChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'heatChartProp_hideLegendLabel': '隱藏圖註',
	'heatChartProp_hideLegendDescription': '隱藏圖註。',
	'heatChartProp_legendPositionLabel': '圖註位置',
	'pieChartCaption': '圓餅圖',
	'pieChartDataSlot_categoriesLabel': '種類',
	'pieChartDataSlot_valuesLabel': '值',
	'pieChartProp_colorPaletteLabel': 'color 選用區',
	'pieChartProp_hideRadialValueLabel': '隱藏值',
	'pieChartProp_pieAsDonutLabel': '顯示為環圈圖',
	'pieChartProp_pieAsDonutDescription': '顯示為環圈圖',
	'pieChartProp_suppressZerosLabel': '隱藏空項目',
	'pieChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'pieChartProp_hideLegendLabel': '隱藏圖註',
	'pieChartProp_hideLegendDescription': '隱藏圖註。',
	'pieChartProp_legendPositionLabel': '圖註位置',
	'map1measureCaption': '地圖',
	'map1measureDataSlot_categoriesLabel': '地區',
	'map1measureDataSlot_valuesLabel': '地區熱度',
	'map1measureProp_colorPaletteLabel': 'color 選用區',
	'map1measureProp_heatScalePaletteLabel': '顏色順序',
	'map1measureProp_maintainAxisScalesLabel': '維護軸刻度',
	'map1measureProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'map1measureProp_suppressZerosLabel': '隱藏空項目',
	'map1measureProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'map1measureProp_hideLegendLabel': '隱藏圖註',
	'map1measureProp_hideLegendDescription': '隱藏圖註。',
	'map1measureProp_legendPositionLabel': '圖註位置',
	'radialChartCaption': '放射狀圖',
	'radialChartDataSlot_categoriesLabel': '種類',
	'radialChartDataSlot_valuesLabel': '值',
	'radialChartProp_colorPaletteLabel': 'color 選用區',
	'radialChartProp_elementColorLabel': '放射狀長條圖顏色',
	'radialChartProp_hideRadialTitleLabel': '隱藏標題',
	'radialChartProp_hideRadialValueLabel': '隱藏值',
	'radialChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'radialChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'radialChartProp_suppressZerosLabel': '隱藏空項目',
	'radialChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'pointChart1catCaption': '點',
	'pointChart1catDataSlot_valuesLabel': '值',
	'pointChart1catDataSlot_categoriesLabel': '軸標籤',
	'pointChart1catProp_colorPaletteLabel': 'color 選用區',
	'pointChart1catProp_elementColorLabel': '形狀顏色',
	'pointChart1catProp_symbolShapeLabel': '符號形狀',
	'pointChart1catProp_symbolFillLabel': '填入形狀',
	'pointChart1catProp_symbolFillDescription': '顯示符號的填入顏色。',
	'pointChart1catProp_hideGridLinesLabel': '隱藏格線',
	'pointChart1catProp_hideGridLinesDescription': '隱藏格線',
	'pointChart1catProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'pointChart1catProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'pointChart1catProp_maintainAxisScalesLabel': '維護軸刻度',
	'pointChart1catProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'pointChart1catProp_suppressZerosLabel': '隱藏空項目',
	'pointChart1catProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'scatterPlotChartNoCatCaption': '散佈平面圖',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': '水平軸',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': '垂直軸',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'color 選用區',
	'scatterPlotChartNoCatProp_elementColorLabel': '元素顏色',
	'scatterPlotChartNoCatProp_symbolShapeLabel': '符號形狀',
	'scatterPlotChartNoCatProp_symbolFillLabel': '填入形狀',
	'scatterPlotChartNoCatProp_symbolFillDescription': '顯示符號的填入顏色。',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': '隱藏格線',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': '隱藏格線',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'radialBarChartCaption': '放射狀長條圖',
	'radialBarChartDataSlot_categoriesLabel': '種類',
	'radialBarChartDataSlot_valuesLabel': '值',
	'radialBarChartProp_colorPaletteLabel': 'color 選用區',
	'radialBarChartProp_elementColorLabel': '放射狀長條圖顏色',
	'radialBarChartProp_hideRadialTitleLabel': '隱藏標題',
	'radialBarChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'radialBarChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'radialBarChartProp_suppressZerosLabel': '隱藏空項目',
	'radialBarChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'lineColumnComboChartCaption': '折線圖和直條圖',
	'lineColumnComboChartDataSlot_categoryLabel': '軸標籤',
	'lineColumnComboChartDataSlot_lineValueLabel': '線條值',
	'lineColumnComboChartDataSlot_columnValueLabel': '直條值',
	'lineColumnComboChartProp_colorPaletteLabel': 'color 選用區',
	'lineColumnComboChartProp_elementColorLabel': '直條圖顏色',
	'lineColumnComboChartProp_lineColorLabel': '線條和符號顏色',
	'lineColumnComboChartProp_symbolShapeLabel': '符號形狀',
	'lineColumnComboChartProp_hideSymbolsLabel': '隱藏符號',
	'lineColumnComboChartProp_hideSymbolsDescription': '隱藏符號',
	'lineColumnComboChartProp_hideDataLinesLabel': '隱藏線條',
	'lineColumnComboChartProp_hideDataLinesDescription': '隱藏線條',
	'lineColumnComboChartProp_interpolationLabel': '平滑線條',
	'lineColumnComboChartProp_interpolationDescription': '連接資料點的線條是曲線。',
	'lineColumnComboChartProp_hideGridLinesLabel': '隱藏格線',
	'lineColumnComboChartProp_hideGridLinesDescription': '隱藏格線',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': '隱藏軸標題標籤',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': '隱藏軸的標題。',
	'lineColumnComboChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'lineColumnComboChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'lineColumnComboChartProp_suppressZerosLabel': '隱藏空項目',
	'lineColumnComboChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'lineColumnComboChartProp_hideLegendLabel': '隱藏圖註',
	'lineColumnComboChartProp_hideLegendDescription': '隱藏圖註。',
	'lineColumnComboChartProp_legendPositionLabel': '圖註位置',
	'summaryCaption': '摘要',
	'areaName': '區域圖',
	'areaDescription': '區域圖',
	'areaDataSlot_colorLabel': '用色方式',
	'areaDataSlot_valuesLabel': '值',
	'areaDataSlot_categoriesLabel': '軸標籤',
	'bubbleName': '泡泡圖',
	'bubbleDescription': '泡泡圖',
	'bubbleDataSlot_yAxisLabel': '垂直軸',
	'bubbleDataSlot_xAxisLabel': '水平軸',
	'bubbleDataSlot_sizeLabel': '大小依據',
	'bubbleDataSlot_colorLabel': '用色方式',
	'clusterBarName': '長條圖',
	'clusterBarDescription': '長條圖',
	'clusterBarDataSlot_colorLabel': '用色方式',
	'clusterBarDataSlot_valuesLabel': '值',
	'clusterBarDataSlot_categoriesLabel': '軸標籤',
	'clusterBarDataSlot_valuesRepeatingLabel': '值',
	'clusterColumnName': '直條圖',
	'clusterColumnDescription': '直條圖',
	'clusterColumnDataSlot_colorLabel': '用色方式',
	'clusterColumnDataSlot_valuesLabel': '值',
	'clusterColumnDataSlot_categoriesLabel': '軸標籤',
	'clusterColumnDataSlot_valuesRepeatingLabel': '值',
	'clusterLineName': '折線圖',
	'clusterLineDescription': '折線圖',
	'clusterLineDataSlot_colorLabel': '用色方式',
	'clusterLineDataSlot_valuesLabel': '垂直軸',
	'clusterLineDataSlot_categoriesLabel': '水平軸',
	'clusterLineDataSlot_valuesRepeatingLabel': '值',
	'gridName': '網格',
	'gridDescription': '網格',
	'gridDataSlot_grid_colsLabel': '直條圖',
	'heatName': '熱圖',
	'heatDescription': '熱圖',
	'heatDataSlot_yAxisLabel': '垂直軸',
	'heatDataSlot_xAxisLabel': '水平軸',
	'heatDataSlot_valuesLabel': '熱度依據',
	'lineColumnComboName': '折線圖和直條圖',
	'lineColumnComboDescription': '折線圖和直條圖',
	'lineColumnComboDataSlot_lineValueLabel': '線條值',
	'lineColumnComboDataSlot_categoryLabel': '軸標籤',
	'lineColumnComboDataSlot_columnValueLabel': '直條值',
	'mapName': '舊地圖',
	'mapDescription': '舊地圖',
	'mapDataSlot_sizeLabel': '點大小',
	'mapDataSlot_valuesLabel': '地區熱度',
	'mapDataSlot_sizeHeatLabel': '點熱度',
	'mapDataSlot_categoriesLabel': '地區',
	'packedBubbleName': '壓縮泡泡圖',
	'packedBubbleDescription': '壓縮泡泡圖',
	'packedBubbleDataSlot_sizeLabel': '大小依據',
	'packedBubbleDataSlot_colorLabel': '用色方式',
	'packedBubbleDataSlot_categoriesLabel': '種類',
	'pieName': '圓餅圖',
	'pieDescription': '圓餅圖',
	'pieDataSlot_valuesLabel': '值',
	'pieDataSlot_categoriesLabel': '種類',
	'playerName': '資料播放程式',
	'playerDescription': '資料播放程式',
	'playerDataSlot_categoriesLabel': '軸標籤',
	'pointName': '點',
	'pointDescription': '點',
	'pointDataSlot_colorLabel': '用色方式',
	'pointDataSlot_valuesLabel': '值',
	'pointDataSlot_categoriesLabel': '軸標籤',
	'radialName': '放射狀圖',
	'radialDescription': '放射狀圖',
	'radialDataSlot_valuesLabel': '值',
	'radialDataSlot_maxSizeLabel': '最大值',
	'radialDataSlot_categoriesLabel': '種類',
	'radialBarName': '放射狀長條圖',
	'radialBarDescription': '放射狀長條圖',
	'radialBarDataSlot_valuesLabel': '值',
	'radialBarDataSlot_categoriesLabel': '種類',
	'scatterPlotName': '散佈平面圖',
	'scatterPlotDescription': '散佈平面圖',
	'scatterPlotDataSlot_yAxisLabel': '垂直軸',
	'scatterPlotDataSlot_xAxisLabel': '水平軸',
	'scatterPlotDataSlot_colorLabel': '用色方式',
	'scatterPlotDataSlot_categoriesLabel': '點圖',
	'stackedBarName': '堆疊長條圖',
	'stackedBarDescription': '堆疊長條圖',
	'stackedBarDataSlot_colorLabel': '用色方式',
	'stackedBarDataSlot_valuesLabel': '值',
	'stackedBarDataSlot_categoriesLabel': '軸標籤',
	'stackedBarDataSlot_valuesRepeatingLabel': '值',
	'stackedColumnName': '堆疊直條圖',
	'stackedColumnDescription': '堆疊直條圖',
	'stackedColumnDataSlot_colorLabel': '用色方式',
	'stackedColumnDataSlot_valuesLabel': '值',
	'stackedColumnDataSlot_categoriesLabel': '軸標籤',
	'stackedColumnDataSlot_valuesRepeatingLabel': '值',
	'summaryChartName': '摘要',
	'summaryChartDescription': '摘要',
	'summaryChartDataSlot_valuesLabel': '值',
	'treeMapName': '樹狀結構圖',
	'treeMapDescription': '樹狀結構圖',
	'treeMapDataSlot_colorLabel': '熱度依據',
	'treeMapDataSlot_valuesLabel': '大小依據',
	'treeMapDataSlot_categoriesLabel': '第一層',
	'treeMapDataSlot_level3Label': '第三層',
	'treeMapDataSlot_level2Label': '第二層',
	'wordCloudName': '文字雲',
	'wordCloudDescription': '文字雲',
	'wordCloudDataSlot_colorLabel': '用色方式',
	'wordCloudDataSlot_scaleLabel': '大小依據',
	'wordCloudDataSlot_wordLabel': '文字',
	'treeMap1Cat1MeasureChartCaption': '樹狀結構圖',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': '第一層',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': '大小依據',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'color 選用區',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'color 選用區',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'color 選用區',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'color 選用區',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'color 選用區',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'color 選用區',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': '維護軸刻度',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': '隱藏空項目',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': '隱藏圖註',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': '隱藏圖註。',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': '圖註位置',
	'wordChart1Cat1MeasureCaption': '文字雲',
	'wordChart1Cat1MeasureDataSlot_wordLabel': '文字',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': '大小依據',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'color 選用區',
	'wordChart1Cat1MeasureProp_elementColorLabel': '文字顏色',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': '維護軸刻度',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': '一律在軸上顯示最小值和最大值。',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': '隱藏空項目',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': '隱藏沒有相關聯值的種類。',
	'missingDataSetData': '此資料集的資料無法使用。請重新整理此資料集，或聯絡管理者以取得來源的存取權。',
	'hideShowSummaries': '隱藏顯示摘要',
	'crosstabName': '交叉資料表',
	'value_is_not_available': 'N/A',
	'swapRowsAndColumns': '交換列和欄',
	'NoPinsCollected': '無固定項目視覺化',
	'pinSearchOld': '搜尋我的固定項目',
	'pinDeletedToast': '已移除固定項目',
	'pinAddedToast': '固定項目已順利新增至我的固定項目',
	'pinRetrieveError': '我們無法擷取一個以上的固定項目。請稍後重試。',
	'pinErrorTitle': '固定錯誤',
	'pinRemove': '移除固定項目',
	'deletePin': '刪除固定項目',
	'dataset_time': '時間',
	'dataset_date': '日期',
	'dataset_location': '位置',
	'dataset_number': '數字',
	'dataset_text': '文字',
	'widgetConditionalFormatLabel': '切換條件式格式控制項',
	'deletePinConfirmationMessage': '您確定要刪除此固定項目嗎？這項作業無法復原。',
	'deletePinConfirm': '確認刪除',
	'pinDeleteError': '我們無法刪除一個以上固定項目。 請稍後重試。',
	'metadataPickerTitle': '建立資料集',
	'moreTitle': '其他',
	'remove_slider_handle': '移除控點',
	'missingFiltering': '直欄遺漏：',
	'unSupportedPromptType': '目前不支援此提示實務範例。',
	'preAggregateLabel': '從資料來源套用提示值',
	'postAggregateLabel': '在報告中套用提示值',
	'preAggregateText': '此範圍會使用資料來源中的值，而不會使用儀表板中所顯示的值。',
	'tabName_general': '一般', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': '詳細資料',
	'tabName_textDetails': '文字詳細資料', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': '媒體詳細資料', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': '網頁詳細資料', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': '映像檔詳細資料', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': '視覺化',
	'sectionName_canvas': '畫布',
	'sectionName_colorsAndThemes': '顏色及佈景主題',
	'colorsAndThemes_legacyWarning': '現行儀表板是使用舊版的佈景主題。變更佈景主題並儲存儀表板會永久地移除舊版佈景主題選用區的存取權。',
	'sectionName_details': '詳細資料',
	'sectionName_positionAndStyle': '位置和樣式',
	'sectionName_appearance': '外觀', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': '進階',
	'sectionName_layout': '佈置', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': '標籤',
	'sectionName_tabTitle': '標籤',
	'sectionName_tabBackground': '背景',
	'addDataSourceDialogTitle': '新增資料來源',
	'addDataSourceDialogButtonLabel': '新增',
	'shapesDoubleChevron': '雙人字紋',
	'widgetsPanelTitle': '小組件',
	'widgetsPanelBasicsTab': '基本',
	'widgetsPanelImageLibraryTab': '影像',
	'widgetsPanelSectionStandard': '標準',
	'widgetsPanelSectionAdvanced': '進階',
	'widgetsPanelSectionShapes': '形狀',
	'customWidgetsTitle': '自訂小組件',
	'filterItemCanvasMove': '新增至畫布',
	'filterOverflowMenu_Global': '所有標籤溢位功能表',
	'filterOverflowMenu_Tab': '此標籤的溢位功能表',
	'filterOverflowMenu_Item': '過濾器溢位功能表',
	'filterOverflowMenu_Single': '溢位功能表',
	'filterItemEdit': '編輯過濾器值',
	'filterDeleteAllItems': '刪除所有過濾器',
	'filterClearAllItems': '清除所有過濾器',
	'filterClearSelection': '清除過濾器',
	'filterPlayerMode': '顯示播放程式',
	'filterStaticMode': '顯示清單',
	'filterInvertSelection': '反轉過濾器',
	'filterIconLabel_Global': '所有標籤',
	'filterIconLabel_Single': '過濾器',
	'filterIconLabel_Tab': '此標籤',
	'filterIconTooltip_Global': '所有標籤',
	'filterIconTooltip_Tab': '此標籤',
	'filterIconTooltip_Single': '過濾器',
	'filterItemDelete': '刪除過濾器',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': '全部，除了：%{from}-%{to}',
	'filterExcept': '除了 %{values}',
	'filterAll': '全部',
	'filterBlank': '（空白）',
	'filterDisableRangeInvert': '當此直欄位於「所有標籤」過濾器中時，則無法使用',
	'filterDisableHierarchyInvert': '當此直欄為階層過濾器時，則無法使用。',
	'filterSelectedOfTotal': '%{selected} 個（共 %{totalMembers} 個）',
	'filter_date_before': '在 %{to} 之前',
	'filter_date_before_except': '不在 %{to} 之前',
	'filter_date_after': '在 %{from} 之後',
	'filter_date_after_except': '不在 %{from} 之後',
	'filter_date_between': '介於 %{from}-%{to} 之間',
	'filter_date_between_except': '未介於 %{from}-%{to} 之間',
	'filter_drag_and_drop_all_tabs': '將資料拖放至此來過濾所有標籤。',
	'filter_drag_and_drop_current_tab': '將資料拖放至此來過濾這個標籤。',
	'filter_drag_and_drop_single_dock': '將資料拖放至此來進行過濾。',
	'errMsgFilterItemGenericTitle': '無法載入過濾器值',
	'widgetChromeRotate': '旋轉',
	'toolbarRegionLabel': '工具列',
	'toolbarActionDelete': '刪除',
	'toolbarActionGroup': '群組',
	'toolbarActionUngroup': '取消群組',
	'toolbarActionOrderToFront': '傳送至前面',
	'toolbarActionOrderToBack': '傳送至後面',
	'toolbarActionEditTitle': '編輯標題',
	'toolbarActionWrapTitle': '覆蓋標題',
	'toolbarActionPin': '收集',
	'toolbarActionPinOld': '固定',
	'toolbarActionAlign': '對齊',
	'alignWidgetLeft': '左',
	'alignWidgetCenter': '置中',
	'alignWidgetRight': '右',
	'alignWidgetTop': '上',
	'alignWidgetMiddle': '中間',
	'alignWidgetBottom': '下',
	'toolbarChangeVisualization': '變更視覺化',
	'multipurposeHeader': '選取小組件類型',
	'multipurposePlaceholderText': '選取其中一個小組件來開始。',
	'live_label': '圖表',
	'filter_label': '過濾',
	'one_named_live': '%{name} 圖表',
	'one_named_live_numbered': '%{name} 圖表 (%{number})',
	'one_unknown_live': '圖表',
	'one_unknown_live_numbered': '圖表 (%{number})',
	'few_live': '%{count} 個圖表的群組',
	'many_live': '%{count} 個圖表的群組',
	'one_custom': '自訂小組件',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} 過濾器',
	'one_named_filter_numbered': '%{name} 過濾器 (%{number})',
	'one_unknown_filter': '過濾',
	'one_unknown_filter_numbered': '過濾器 (%{number})',
	'few_filter': '%{count} 個過濾器的群組',
	'many_filter': '%{count} 個過濾器的群組',
	'LIVE_bar_has_mapping': '%{values} 長條圖',
	'LIVE_bar_has_mapping_numbered': '%{values} 長條圖 (%{number})',
	'LIVE_bar_opt_mapping': '%{categories}〈依 %{values}）長條圖',
	'LIVE_bar_opt_mapping_numbered': '%{categories}（依 %{values}）長條圖 (%{number})',
	'LIVE_bar_no_mapping': '空的長條圖',
	'LIVE_bar_no_mapping_numbered': '空的長條圖 (%{number})',
	'LIVE_bar_named': '%{name} 長條圖',
	'LIVE_bar_named_numbered': '%{name} 長條圖 (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} 堆疊長條圖',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} 堆疊長條圖 (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories}（依 %{values}）堆疊長條圖',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories}（依 %{values}）堆疊長條圖 (%{number})',
	'LIVE_stacked_bar_no_mapping': '空的堆疊長條圖',
	'LIVE_stacked_bar_no_mapping_numbered': '空的堆疊長條圖 (%{number})',
	'LIVE_stacked_bar_named': '%{name} 堆疊長條圖',
	'LIVE_stacked_bar_named_numbered': '%{name} 堆疊長條圖 (%{number})',
	'LIVE_bubble_has_mapping': '%{categories}（依 %{x} 和 %{y}）泡泡圖',
	'LIVE_bubble_has_mapping_numbered': '%{categories}（依 %{x} 和 %{y}）泡泡圖 (%{number})',
	'LIVE_bubble_no_mapping': '空的泡泡圖',
	'LIVE_bubble_no_mapping_numbered': '空的泡泡圖 (%{number})',
	'LIVE_bubble_named': '%{name} 泡泡圖',
	'LIVE_bubble_named_numbered': '%{name} 泡泡圖 (%{number})',
	'LIVE_composite_has_mapping': '%{categories}（依 %{columnValue} 和 %{lineValue}）組合圖',
	'LIVE_composite_has_mapping_numbered': '%{categories}（依 %{columnValue} 和 %{lineValue}）組合圖 (%{number})',
	'LIVE_composite_no_mapping': '空的組合圖',
	'LIVE_composite_no_mapping_numbered': '空的組合圖 (%{number})',
	'LIVE_composite_named': '%{name} 組合圖',
	'LIVE_composite_named_numbered': '%{name} 組合圖 (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} 決策樹狀結構',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} 決策樹狀結構 (%{number})',
	'LIVE_decision_tree_no_mapping': '空的決策樹狀結構',
	'LIVE_decision_tree_no_mapping_numbered': '空的決策樹狀結構 (%{number})',
	'LIVE_decision_tree_named': '%{name} 決策樹狀結構',
	'LIVE_decision_tree_named_numbered': '%{name} 決策樹狀結構 (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} 壓縮泡泡圖',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} 壓縮泡泡圖 (%{number})',
	'LIVE_packed_bubble_no_mapping': '空的壓縮泡泡圖',
	'LIVE_packed_bubble_no_mapping_numbered': '空的壓縮泡泡圖 (%{number})',
	'LIVE_packed_bubble_named': '%{name} 壓縮泡泡圖',
	'LIVE_packed_bubble_named_numbered': '%{name} 壓縮泡泡圖 (%{number})',
	'LIVE_pie_has_mapping': '%{categories}（依 %{values}）圓餅圖',
	'LIVE_pie_has_mapping_numbered': '%{categories}（依 %{values}）圓餅圖 (%{number})',
	'LIVE_pie_no_mapping': '空的圓餅圖',
	'LIVE_pie_no_mapping_numbered': '空的圓餅圖 (%{number})',
	'LIVE_pie_named': '%{name} 圓餅圖',
	'LIVE_pie_named_numbered': '%{name} 圓餅圖 (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories}（依 %{values}）環圈圖',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories}（依 %{values}）環圈圖 (%{number})',
	'LIVE_pie_as_donut_no_mapping': '空的環圈圖',
	'LIVE_pie_as_donut_no_mapping_numbered': '空的環圈圖 (%{number})',
	'LIVE_pie_as_donut_named': '%{name} 環圈圖',
	'LIVE_pie_as_donut_named_numbered': '%{name} 環圈圖 (%{number})',
	'LIVE_line_has_mapping': '%{categories}（依 %{values}）折線圖',
	'LIVE_line_has_mapping_numbered': '%{categories}（依 %{values}）折線圖 (%{number})',
	'LIVE_line_no_mapping': '空的折線圖',
	'LIVE_line_no_mapping_numbered': '空的折線圖 (%{number})',
	'LIVE_line_named': '%{name} 折線圖',
	'LIVE_line_named_numbered': '%{name} 折線圖 (%{number})',
	'LIVE_area_has_mapping': '%{categories}（依 %{values}）區域圖',
	'LIVE_area_has_mapping_numbered': '%{categories}（依 %{values}）區域圖 (%{number})',
	'LIVE_area_no_mapping': '空的區域圖',
	'LIVE_area_no_mapping_numbered': '空的區域圖 (%{number})',
	'LIVE_area_named': '%{name} 區域圖',
	'LIVE_area_named_numbered': '%{name} 區域圖 (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories}（依 %{values}）堆疊百分比區域圖',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories}（依 %{values}）堆疊百分比區域圖 (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': '空的堆疊百分比區域圖',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': '空的堆疊百分比區域圖 (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} 堆疊百分比區域圖',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} 堆疊百分比區域圖 (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} 熱圖',
	'LIVE_heatmap_has_mapping_numbered': '%{color} 熱圖 (%{number})',
	'LIVE_heatmap_no_mapping': '空的熱圖',
	'LIVE_heatmap_no_mapping_numbered': '空的熱圖 (%{number})',
	'LIVE_heatmap_named': '%{name} 熱圖',
	'LIVE_heatmap_named_numbered': '%{name} 熱圖 (%{number})',
	'LIVE_network_opt_mapping': '%{categories}（依 %{series} 和 %{values}）網路',
	'LIVE_network_opt_mapping_numbered': '%{categories}（依 %{series} 和 %{values}）網路 (%{number})',
	'LIVE_network_has_mapping': '%{categories}（依 %{series}）網路',
	'LIVE_network_has_mapping_numbered': '%{categories}（依 %{series}）網路 (%{number})',
	'LIVE_network_no_mapping': '空的網路',
	'LIVE_network_no_mapping_numbered': '空的網路 (%{number})',
	'LIVE_network_named': '%{name} 網路',
	'LIVE_network_named_numbered': '%{name} 網路 (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories}（依 %{values}）放射狀長條圖',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories}（依 %{values}）放射狀長條圖 (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} 放射狀長條圖',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} 放射狀長條圖 (%{number})',
	'LIVE_radial_bar_no_mapping': '空的放射狀長條圖',
	'LIVE_radial_bar_no_mapping_numbered': '空的放射狀長條圖 (%{number})',
	'LIVE_radial_bar_named': '%{name} 放射狀長條圖',
	'LIVE_radial_bar_named_numbered': '%{name} 放射狀長條圖 (%{number})',
	'LIVE_spiral_has_mapping': '%{values} 螺旋圖',
	'LIVE_spiral_has_mapping_numbered': '%{values} 螺旋圖 (%{number})',
	'LIVE_spiral_no_mapping': '空的螺旋圖',
	'LIVE_spiral_no_mapping_numbered': '空的螺旋圖 (%{number})',
	'LIVE_spiral_named': '%{name} 螺旋圖',
	'LIVE_spiral_named_numbered': '%{name} 螺旋圖 (%{number})',
	'LIVE_treemap_has_mapping': '%{categories}（依 %{size}）樹狀結構圖',
	'LIVE_treemap_has_mapping_numbered': '%{categories}（依 %{size}）樹狀結構圖 (%{number})',
	'LIVE_treemap_no_mapping': '空的樹狀結構圖',
	'LIVE_treemap_no_mapping_numbered': '空的樹狀結構圖 (%{number})',
	'LIVE_treemap_named': '%{name} 樹狀結構圖',
	'LIVE_treemap_named_numbered': '%{name} 樹狀結構圖 (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} 文字雲',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} 文字雲 (%{number})',
	'LIVE_wordcloud_no_mapping': '空的文字雲',
	'LIVE_wordcloud_no_mapping_numbered': '空的文字雲 (%{number})',
	'LIVE_wordcloud_named': '%{name} 文字雲',
	'LIVE_wordcloud_named_numbered': '%{name} 文字雲 (%{number})',
	'LIVE_data_player_has_mapping': '%{category} 資料播放程式',
	'LIVE_data_player_has_mapping_numbered': '%{category} 資料播放程式 (%{number})',
	'LIVE_data_player_no_mapping': '空的資料播放程式',
	'LIVE_data_player_no_mapping_numbered': '空的資料播放程式 (%{number})',
	'LIVE_data_player_named': '%{name} 資料播放程式',
	'LIVE_data_player_named_numbered': '%{name} 資料播放程式 (%{number})',
	'LIVE_map_has_mapping': '%{locations} 地圖',
	'LIVE_map_has_mapping_numbered': '%{locations} 地圖 (%{number})',
	'LIVE_map_no_mapping': '空的地圖',
	'LIVE_map_no_mapping_numbered': '空的地圖 (%{number})',
	'LIVE_map_named': '%{name} 地圖',
	'LIVE_map_named_numbered': '%{name} 地圖 (%{number})',
	'LIVE_point_has_mapping': '%{categories}（依 %{values}）點圖',
	'LIVE_point_has_mapping_numbered': '%{categories}（依 %{values}）點圖 (%{number})',
	'LIVE_point_no_mapping': '空的點圖',
	'LIVE_point_no_mapping_numbered': '空的點圖 (%{number})',
	'LIVE_point_named': '%{name} 點圖',
	'LIVE_point_named_numbered': '%{name} 點圖 (%{number})',
	'LIVE_column_has_mapping': '%{values} 直條圖',
	'LIVE_column_has_mapping_numbered': '%{values} 直條圖 (%{number})',
	'LIVE_column_opt_mapping': '%{categories} by %{values} 直條圖',
	'LIVE_column_opt_mapping_numbered': '%{categories} by %{values} 直條圖 (%{number})',
	'LIVE_column_no_mapping': '空的直條圖',
	'LIVE_column_no_mapping_numbered': '空的直條圖 (%{number})',
	'LIVE_column_named': '%{name} 直條圖',
	'LIVE_column_named_numbered': '%{name} 直條圖 (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} 堆疊直條圖',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} 堆疊直條圖 (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories}（依 %{values}）堆疊直條圖',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories}（依 %{values}）堆疊直條圖 (%{number})',
	'LIVE_stacked_column_no_mapping': '空的堆疊直條圖',
	'LIVE_stacked_column_no_mapping_numbered': '空的堆疊直條圖 (%{number})',
	'LIVE_stacked_column_named': '%{name} 堆疊直條圖',
	'LIVE_stacked_column_named_numbered': '%{name} 堆疊直條圖 (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories}（依 %{x} 和 %{y}）散佈平面圖',
	'LIVE_scatter_opt_mapping_numbered': '%{categories}（依 %{x} 和 %{y}）散佈平面圖 (%{number})',
	'LIVE_scatter_has_mapping': '%{x} 與 %{y} 散佈平面圖',
	'LIVE_scatter_has_mapping_numbered': '%{x} 與 %{y} 散佈平面圖 (%{number})',
	'LIVE_scatter_no_mapping': '空的散佈平面圖',
	'LIVE_scatter_no_mapping_numbered': '空的散佈平面圖 (%{number})',
	'LIVE_scatter_named': '%{name} 散佈平面圖',
	'LIVE_scatter_named_numbered': '%{name} 散佈平面圖 (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} 瀑布圖',
	'LIVE_waterfall_has_mapping_numbered': '%{values} 瀑布圖 (%{number})',
	'LIVE_waterfall_no_mapping': '空的瀑布圖',
	'LIVE_waterfall_no_mapping_numbered': '空的瀑布圖 (%{number})',
	'LIVE_waterfall_named': '%{name} 瀑布圖',
	'LIVE_waterfall_named_numbered': '%{name} 瀑布圖 (%{number})',
	'LIVE_empty_visualization_hint_title': '建置您的視覺化',
	'LIVE_empty_visualization_hint_description': '將直欄拖放至此或至左側的槽上。',
	'LIVE_slots_required_field_description': '%{asterisk} 指出必要欄位',
	'LIVE_slots_drag_and_drop_description': '將資料拖放至此上方的槽來建置及過濾視覺化。',
	'requiredField': '必要欄位',
	'fullScreenEnter': '進入全螢幕',
	'fullScreenClose': '結束全螢幕',
	'noExtraText_multipurpose': '多用途位置保留元',
	'noExtraText_multipurpose_numbered': '多用途位置保留元 (%{number})',
	'one_placeholder_vis': '視覺化位置保留元',
	'one_placeholder_vis_numbered': '視覺化位置保留元 (%{number})',
	'one_placeholder_text': '文字位置保留元',
	'one_placeholder_text_numbered': '文字位置保留元 (%{number})',
	'few_placeholder_text': '%{count} 個文字位置保留元的群組',
	'many_placeholder_text': '%{count} 個文字位置保留元的群組',
	'filter_includesAll': '併入全部',
	'timeline_filter_moved_to': '時間表過濾器 %{id} 移至 %{time}',
	'timelineSettingsButton': '播放選項',
	'autoPlay': '播放全部場景',
	'loop': '循環播放',
	'noSceneTransitionLabel': '無',
	'sceneTransitionPropertyLabel': '場景轉移',
	'animatedPathSceneTransitionLabel': '動畫路徑',
	'sweepSceneTransitionLabel': '過光效果',
	'propAniAnimation': '動畫',
	'propAniTypeEntrance': '進場動畫',
	'propAniDirectionIn': '進場方向',
	'propAniTypeExit': '離場動畫',
	'propAniDirectionOut': '離場方向',
	'propAniDirection': '方向',
	'timelineAnimationProperties': '開啟動畫內容',
	'editStoryCoachMarkTitle': '編輯案例',
	'editStoryCoachMarkContents': '按一下鉛筆圖示以編輯此案例。',
	'addDataStoryCoachMarkContents': '將資料從資料畫面拖放到您的案例。',
	'expandSceneCoachmarkTitle': '開啟時間表',
	'expandSceneCoachmarkContents': '根據時間及持續時間調整物件可見性，以動畫方式顯示場景。',
	'overviewCoachmarkTitle': '概觀場景',
	'overviewCoachmarkContents': '使用案例開始和結束時的概觀場景來顯示所有場景的大圖片。從概觀場景中，按一下並拖曳場景以將其與另一個場景交換。您可以在案例內容中顯示或隱藏概觀場景。',
	'animatedPathCoachmarkTitle': '動畫路徑',
	'animatedPathCoachmarkContents': '若要讓物件從一個場景到另一個場景進行動畫，請重複具有物件的場景。然後，對新場景上的重複物件進行移動、調整大小或旋轉的動作。',
	'tabName_animation': '動畫',
	'textWidgetIconPlaceholderText': '按一下以新增文字',
	'buildVisHeader': '建立視覺化',
	'visIconPlaceholderText': '拖放欄位以建置視覺化',
	'launchNewExplore': '新建探索',
	'addTo': '新增目標',
	'addToExisting': '新增至現有項目…',
	'exploreData': '瀏覽',
	'explore_remove_widget_styles': '自訂視覺化內容（例如色彩設定）將不會在您的探索中持續保存。',
	'editNotebook': '編輯小組件',
	'thumbnails_error_fetching': '提取縮圖時發生錯誤',
	'copy': '%{count} 個資產已複製',
	'specConvertErr': '貼上或轉換儀表板規格時發生錯誤',
	'specCopyErr': '複製儀表板規格時發生錯誤',
	'pasteNotSupportedErr': '不支援從 %{name} 貼上。',
	'reportParam': '報告',
	'filterWidgetCopyWarn': '未複製過濾器視覺化，因為此時不支援過濾器。',
	'upgradingDashboard': '升級 %{version} 的 "%{name}"...',
	'upgradeComplete': '升級完成',
	'individualTabProperties': '個別標籤內容',
	'propMasterTabStylesLabel': '主要標籤樣式',
	'propTabPosition': '標籤位置',
	'propTabTitle': '標題',
	'propTabBackgroundColor': '填入顏色',
	'propTabTextColor': '標題顏色',
	'propTabSelectedBarColor': '選取條欄顏色',
	'propTabRestoreDefaults': '還原預設值',
	'propIndividualTabStylesLabel': '個別標籤樣式',
	'propIndividualTabStylesAriaLabel': '開啟個別標籤樣式內容',
	'propTabIconPosition': '圖示位置',
	'propLeftTitle': '標題左邊',
	'propRightTitle': '標題右邊',
	'propTopTitle': '上方標題',
	'propBottomTitle': '下方標題',
	'propTabIconLabel': '視覺化',
	'propTabIcon': '圖示',
	'propTabIconColor': '圖示顏色',
	'no_icon': '空的',
	'announcement': '公告',
	'api': 'API',
	'archive': '保存檔',
	'asset': '資產',
	'attachment': '附件',
	'audio': '音訊',
	'bee': 'Bee',
	'blog': '部落格',
	'bookmark': '書籤',
	'calendar': '行事曆',
	'camera': '相機',
	'capability': '功能',
	'catalog': '型錄',
	'chat_message': '會談訊息',
	'checkout_cart': '結帳購物車',
	'client': '用戶端',
	'clock': '時鐘',
	'cloud': '雲',
	'code': '代碼',
	'data_quality': '資料品質',
	'folder': '資料夾',
	'forum': '討論區',
	'glasses': '眼鏡',
	'group': '群組',
	'hat': '帽子',
	'headphone': '耳機',
	'hills': '山丘',
	'home': '首頁',
	'idea': '構想',
	'image': '影像',
	'inventory': '庫存',
	'like': '喜歡',
	'link': '鏈結',
	'location': '位置',
	'manage': '管理',
	'pen': '畫筆',
	'mobile_phone': '行動電話',
	'music': '音樂',
	'notifications': '通知',
	'paint': '繪製',
	'payment': '付款',
	'password_key': '密碼',
	'people': '人員',
	'person': '個人',
	'phone': '電話',
	'pin': '固定',
	'print': '列印',
	'recording': '錄製',
	'repository': '儲存庫',
	'role': '角色',
	'search': '搜尋',
	'properties': '內容',
	'speaker': '喇叭',
	'star': '星形',
	'tag': '標籤',
	'thumbs_up': '很讚',
	'thumbs_down': '很遜',
	'tools': '工具',
	'traffic': '資料流量',
	'trash': '垃圾',
	'twitter': 'Twitter',
	'unknown': '不明',
	'user': '使用者',
	'venn_diagram': '凡氏圖',
	'video': '影片',
	'view': '檢視',
	'warning': '警告',
	'watch': '監看',
	'watson': 'Watson',
	'wikis': 'WIKI',
	'workspace': '工作區',
	'world': '世界',
	'OnLoadFilterModifierDatasourceMismatch': '過濾器將不會套用至目標，因為儀表板正在使用不同來源。',
	'OnLoadFilterModifierColumnMismatch': '一個以上的過濾器未套用，因為找不到相符的直欄。',
	'eventGroupButtonLabel': '檢視小組件連線',
	'dockToolbar': '對接工具列',
	'undockToolbar': '取消對接工具列',
	'propShowTitle': '顯示標題'
});
